import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import useMediaQuery from '@material-ui/core/useMediaQuery';
import { useSelector } from 'react-redux';
import { PAGES_SLUGS } from '../../../constants';
import _get from 'lodash/get';
import ReactHtmlParser from "react-html-parser";
import bannerStatic from "../../../../images/listing-banner-fara-rabla.jpg";

const useStyles = makeStyles((theme) => ({
  root: {
    position: 'relative',
    width: '100%',
    height: '300px',
    marginBottom: theme.spacing(2),
    borderRadius: theme.spacing(1),
    overflow: 'hidden',
    [theme.breakpoints.down('sm')]: {
      height: '318px',
      borderRadius: theme.spacing(0.1)
    },
  },
  headerImage: {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    objectPosition: 'center',
    [theme.breakpoints.down('sm')]: {
      objectPosition: '50% 35%',
      borderRadius: theme.spacing(2)
    }
  },
  content: {
    position: 'absolute',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing(2),
    color: '#fff',
    textAlign: 'center',
  },
  title: {
    fontSize: '38px',
    fontWeight: 400,
    marginBottom: theme.spacing(2),
    letterSpacing: '0.4px',
    color: "#FFF",
  },
  text: {
    fontSize: '14px',
    fontWeight: 400,
    maxWidth: '80%',
    textAlign: 'center',
    letterSpacing: "0.64px",
    color: "#FFF", // Use the primary color from the theme
    '& span': {
      display: 'inline-block',
      margin: '0 8px',
    },
  },
}));

const TopSectionFaraRabla = () => {
  const classes = useStyles();
  const isMobile = useMediaQuery(theme => theme.breakpoints.down('sm'));
  const pageData = useSelector(state => _get(state.pages.data, PAGES_SLUGS.PRODUCTS, {}));
  const pageContent = _get(pageData, 'data.ro', {});

  const header_image = _get(pageContent, 'header_image', {});
  const highlight_image = _get(pageContent, 'highlight_image', {});
  const title = _get(pageContent, 'top_section_title', 'Oferte Volvo');
  const content = _get(pageContent, 'top_section_content', '');

  return (
    <Box className={classes.root}>
      <img
        src={bannerStatic}
        alt={title}
        className={classes.headerImage}
      />
      <Box className={classes.content}>
        <Typography className={classes.title}>
          {title}
        </Typography>
        <Typography className={classes.text}>
          {ReactHtmlParser(content)}
        </Typography>
      </Box>
    </Box>
  );
};

export default TopSectionFaraRabla;
